import { render, staticRenderFns } from "./DetailPemutakhiranPembatalanKkprl.vue?vue&type=template&id=68507ec8&"
import script from "./DetailPemutakhiranPembatalanKkprl.vue?vue&type=script&lang=js&"
export * from "./DetailPemutakhiranPembatalanKkprl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports